import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathBasic: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="math-basic, calc">
      <path
        d="M7 4V10M4 7H10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M14 7H20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M14 17H20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M4.5 14.5L7.00002 17M7.00002 17L9.5 19.5M7.00002 17L4.5 19.5M7.00002 17L9.5 14.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17 14H17.0001"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M17 20H17.0001"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </CentralIconBase>
  );
};

export default IconMathBasic;
